import React, { Component } from "react";
import { CardElement, ElementsConsumer } from "@stripe/react-stripe-js";
import { Modal } from "react-bootstrap";
import Popup from "reactjs-popup";
import { fire, auth } from "../../firebase/index";
import NotificationSystem from "react-notification-system";
import { style } from "variables/Variables.jsx";
import withAuthorization from "../../components/Authorization/withAuthorization";
import ContactCustomPlan from "../ContactUs/ContactUsCustomPlan";
import Switch from "react-switch";
import ipapi from "ipapi.co";
import {
  egeeTouchPlans,
  planToNumber,
  customLog,
} from "../../variables/Variables";
import "../../assets/css/maincss.css";
import {
  getToday,
  cancelSub,
  showConfirmAlert,
  updateUserDetails,
  updateExistingGroupAccounts,
  pushNewGroupAccounts,
  planSubscription,
  changePlan,
} from "./StripeHelper";

import LocalizedStrings from "react-localization";

// -------------------- i18n strings (unchanged from your version) --------------------
let localizationStrings = new LocalizedStrings({
  en: {
    freePackage: egeeTouchPlans.egeeTouchplan21.planName,
    starterNewPackage: egeeTouchPlans.egeeTouchplan22.planName,
    lockFocusPackage: egeeTouchPlans.egeeTouchplan23.planName,
    proLocksPackage: egeeTouchPlans.egeeTouchplan24.planName,
    userFocusPackage: egeeTouchPlans.egeeTouchplan25.planName,
    proUsersPackage: egeeTouchPlans.egeeTouchplan26.planName,
    largeAppPackage: egeeTouchPlans.egeeTouchplan27.planName,

    freePackagePlanPrice: "$00.00/month",
    starterNewPlanPrice: "$7.90/month",
    lockFocusPlanPrice: "$24.90/month",
    proLocksPlanPrice: "$109.00/month",
    userFocusPlanPrice: "$69.90/month",
    proUsersPlanPrice: "$199.90/month",
    largeAppPlanPrice: "$478.90/month",

    freePackagePlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan21.planPrice + "/month",
    starterNewPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan22.planPrice + "/month",
    lockFocusPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan23.planPrice + "/month",
    proLocksPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan24.planPrice + "/month",
    userFocusPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan25.planPrice + "/month",
    proUsersPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan26.planPrice + "/month",
    largeAppPlanPriceDiscount:
      egeeTouchPlans.egeeTouchplan27.planPrice + "/month",

    freePackagePlanPriceAnnual: "$00.00/year",
    starterNewPlanPriceAnnual: "$83.42/year",
    lockFocusPlanPriceAnnual: "$262.94/year",
    proLocksPlanPriceAnnual: "$1,151.04/year",
    userFocusPlanPriceAnnual: "$738.14/year",
    proUsersPlanPriceAnnual: "$2,101.44/year",
    largeAppPlanPriceAnnual: "$5,047.68/year",

    freePlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan21.planPriceAnnual + "/year",
    starterNewPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan22.planPriceAnnual + "/year",
    lockFocusPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan23.planPriceAnnual + "/year",
    proLocksPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan24.planPriceAnnual + "/year",
    userFocusPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan25.planPriceAnnual + "/year",
    proUsersPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan26.planPriceAnnual + "/year",
    largeAppPlanPriceAnnualDiscount:
      egeeTouchPlans.egeeTouchplan27.planPriceAnnual + "/year",

    freePlanName: egeeTouchPlans.egeeTouchplan21.planName,
    starterNewPlanName: egeeTouchPlans.egeeTouchplan22.planName,
    lockFocusPlanName: egeeTouchPlans.egeeTouchplan23.planName,
    proLocksPlanName: egeeTouchPlans.egeeTouchplan24.planName,
    userFocusPlanName: egeeTouchPlans.egeeTouchplan25.planName,
    proUsersPlanName: egeeTouchPlans.egeeTouchplan26.planName,
    largeAppPlanName: egeeTouchPlans.egeeTouchplan27.planName,

    freePlanNameEg: egeeTouchPlans.egeeTouchplan21.planName,
    starterNewPlanNameEg: egeeTouchPlans.egeeTouchplan22.planName,
    lockFocusPlanNameEg: egeeTouchPlans.egeeTouchplan23.planName,
    proLocksPlusPlanNameEg: egeeTouchPlans.egeeTouchplan24.planName,
    userFocusPlanNameEg: egeeTouchPlans.egeeTouchplan25.planName,
    proUsersPlanNameEg: egeeTouchPlans.egeeTouchplan26.planName,
    largeAppPlanNameEg: egeeTouchPlans.egeeTouchplan27.planName,

    switchToStarterNewButton: "Switch To Starter New",
    switchToLockFocusButton: "Switch To Lock Focus",
    switchToProLocksButton: "Switch To Pro Locks",
    switchToUserFocusButton: "Switch To User Focus",
    switchToProUsersButton: "Switch To Pro Users",
    switchToLargeAppsButton: "Switch To Large Apps",
    NewUserButton: "Try for free",
    buyStarterNewButton: "Buy Starter New",
    buyLockFocusButton: "Buy Lock Focus",
    buyProLocksButton: "Buy Pro Locks",
    buyUserFocusButton: "Buy User Focus",
    buyProUsersButton: "Buy Pro Users",
    buyLargeAppButton: "Buy Large Apps",
    submitButton: "Submit",
    trialPopupTitle: "Activate subscription package?",
    trialPopupDescription_1: "You will be activating a",
    trialPopupDescription_2: " 14 days trial ",
    trialPopupDescription_3: "run of the system.",
    trialPopupDescription1:
      "To continue using the system after the trial, you are required to add a payment method.",
    trialButton: "Confirm",
    trialTitle: "14 days FREE trial period",
    padlockTitle: "Smart Padlocks*",
    userAccountsTitle: "User Accounts",
    maxMultiApproval: "Layer of Multi Approval",
    monthlyTitle: "Monthly",
    annualTitle: "Annual",
    saveAmtTitle: "Save 12% extra!",
    nameOnCardTitle: "Name on Card",
    billingAddressTitle: "Billing Address",
    cancelSubTitle: "Cancel Subscription",
    deleteTitleTitle: "We're sad to see you go ! ",
    deleteMessageTitle: "Confirm cancellation of subscription ?",
    confirmTitle: "Confirm",
    cancelTitle: "Cancel",
    warningTitles1: "Require Custom Plan?",
    warningTitles2: "Please contact sales at info@egeetouch.com",
    buyStarterPlusButton: "Buy Starter Plus",
    buyEssentialPlusButton: "Buy Essential Plus",
    switchToStarterPlusButton: "Switch To Starter Plus",
    switchToEssentialPlusButton: "Switch To Essent Plus",
    uptoTitle: "Up to",
    warningTitles3:
      "*Subscription Package for Intelligent Access Management (IAM) System does not include eGeeTouch Smart Padlocks. eGeeTouch Smart Padlocks are SOLD SEPARATELY",
    paymentFailNotif1: "Payment ",
    paymentFailNotif2: "failed, Please try again later !",
    cardDeclinedNotif1: "Your card has been ",
    cardDeclinedNotif2: "declined",
    invalidCredentialsNotif:
      "Please ensure that you have entered the correct card information !",
    paymentErrorNotif: "An error occurred. Please try again later.",
    popupWarning: "Warning",
    userExists: "User account already exists, do you want to remove?",
    removeBtn: "Remove",
    cancelBtn: "Cancel",
    noCardMessage: "No card required",
    cancellationHeader: "Subscription Cancellation",
    feedbackQ1: "Let us know your reasons for canceling the subscription",
    feedbackQ2: "How long have you been subscribed ?",
    feedbackQ3: "How would you rate your overall experience with our service ?",
    feedbackQ4: "Feel free to provide any additional feedback (Optional)",
    reason1: "We don't need the service anymore",
    reason2: "The service is difficult to use",
    reason3: "The service lacks features that we need",
    reason4: "We want to change the subscription plan",
    reason5: "We will move to another service provider instead",
    reason6: "It is too expensive",
    reason7: "We have privacy concerns",
    reason8: "The cancellation is only temporary",
    reason9: "Others",
    specifyReason: "Please specify your reasons",
    duration1: "Less than a month",
    duration2: "1 - 3 months",
    duration3: "4 - 12 months",
    duration4: "1 - 2 years",
    duration5: "More than 3 years",
    veryPoor: "Very Poor",
    excellent: "Excellent",
    proceed: "Proceed",
    return: "Return",
    cancellationFormIncomplete: "Please complete the feedback form to proceed",
    cancellationFormOtherReason:
      "You have selected 'Others' in the first question, please specify your reasons",
    close: "Close",
    oops: "Oops!",
    noPlanError:
      "It looks like you don't have any existing plan with us to cancel !",
    subscriptionCancelled: "Subscription cancelled",
    subscriptionCancelledMsg:
      "Your subscription has been cancelled successfully !",
    // ----- Units -----
    unitMonth: "Month",
    unitYear: "Year",

    // ----- Table labels -----
    labelLock: "LOCK",
    labelAppUsers: "App Users",
    labelNfcFobUsers: "NFC Fob Users",
    labelMultiApproval: "Multi Approval",
    labelRemarks: "Remarks",
    labelTotalUsers: "Total Users",

    // ----- CTA buttons -----
    ctaTryFree: "Try for FREE",
    ctaSubscribeNow: "Subscribe Now",
    ctaChangePlan: "Change Plan",
    currentPlanButton: "Current Plan",
    freeTrialUnavailable: "Free trial is not available",

    // ----- Notifications / toasts -----
    changingPlanNoti: "Changing plan… Please do not close the page.",
    switchFailedNoti: "Unable to change plan. Please try again later.",
    subscriptionSuccessNoti: "Plan changed successfully. Refreshing page…",
    invalidCardNotif: "Invalid card information. Please check and try again.",
    planHeaders: [
      "Free",
      "Starter",
      "Lock Focus",
      "Pro Locks",
      "User Focus",
      "Pro Users",
      "Large App",
    ],
    remarkFree:
      "Mobile App Only <br> Free 14 days trial for IAM Web System <br> (No Credit Card Needed)",
    remarkStarter:
      "Entry Level and Pilot Testing.<br> Each lock can be accessed Up to 8 users",
    remarkEachLockUpTo: "Each lock can be accessed Up to {n} users",
  },
  ja: {
    // plan display names (keep actual names from your plan config)
    freePackage: egeeTouchPlans.egeeTouchplan21.planNameJP,
    starterNewPackage: egeeTouchPlans.egeeTouchplan22.planNameJP,
    lockFocusPackage: egeeTouchPlans.egeeTouchplan23.planNameJP,
    proLocksPackage: egeeTouchPlans.egeeTouchplan24.planNameJP,
    userFocusPackage: egeeTouchPlans.egeeTouchplan25.planNameJP,
    proUsersPackage: egeeTouchPlans.egeeTouchplan26.planNameJP,
    largeAppPackage: egeeTouchPlans.egeeTouchplan27.planNameJP,

    // headers
    planHeaders: [
      "無料プラン",
      "スタータープラン",
      "LFプラン",
      "Pro-LFプラン",
      "UFプラン",
      "Pro-UFプラン",
      "LAプラン",
    ],
    groupEntry: "エントリー",
    groupMoreLockLessUser: "ロック多・ユーザー少",
    groupMoreUserLessLock: "ユーザー多・ロック少",
    groupLargeApplication: "大規模利用",

    monthlyTitle: "月額",
    annualTitle: "年額",
    saveAmtTitle: "さらに12%お得！",
    unitMonth: "月",
    unitYear: "年",

    ctaTryFree: "無料で試す",
    ctaSubscribeNow: "今すぐ申し込む",
    ctaChangePlan: "プラン変更",
    currentPlanButton: "現在のプラン",
    freeTrialUnavailable: "無料トライアルは利用できません",

    labelLock: "スマートロック台数",
    labelAppUsers: "アプリ登録メンバー数",
    labelNfcFobUsers: "NFC登録数",
    labelMultiApproval: "承認者数",
    labelRemarks: "備考",
    labelTotalUsers: "ご利用可能メンバー数",

    submitButton: "送信",
    nameOnCardTitle: "カード名義",
    billingAddressTitle: "請求先住所",

    trialPopupTitle: "サブスクリプションを有効化しますか？",
    trialPopupDescription_1: "",
    trialPopupDescription_2: "14日間の無料トライアル",
    trialPopupDescription_3: "を開始します。",
    trialPopupDescription1:
      "トライアル終了後も継続利用するには、お支払い方法の登録が必要です。",
    trialButton: "確認",

    cancelSubTitle: "サブスクリプションを解約",
    deleteTitleTitle: "ご利用ありがとうございました",
    deleteMessageTitle: "サブスクリプションを解約しますか？",
    confirmTitle: "確認",
    cancelTitle: "キャンセル",
    close: "閉じる",
    oops: "エラー",
    noPlanError: "解約できる有効なプランが見つかりません。",
    subscriptionCancelled: "解約完了",
    subscriptionCancelledMsg: "サブスクリプションの解約が完了しました。",

    cancellationHeader: "解約アンケート",
    feedbackQ1: "解約理由を教えてください",
    feedbackQ2: "ご利用期間を教えてください",
    feedbackQ3: "サービスの満足度を教えてください",
    feedbackQ4: "その他ご意見（任意）",
    reason1: "もうサービスが不要になった",
    reason2: "使い方が難しい",
    reason3: "必要な機能が不足している",
    reason4: "別のプランに変更したい",
    reason5: "他社サービスに移行する",
    reason6: "価格が高い",
    reason7: "プライバシーが不安",
    reason8: "一時的に解約したい",
    reason9: "その他",
    specifyReason: "理由を入力してください",
    duration1: "1か月未満",
    duration2: "1〜3か月",
    duration3: "4〜12か月",
    duration4: "1〜2年",
    duration5: "3年以上",
    veryPoor: "不満",
    excellent: "大満足",
    proceed: "進む",
    return: "戻る",
    cancellationFormIncomplete:
      "未入力項目があります。回答してから進んでください。",
    cancellationFormOtherReason:
      "「その他」を選択した場合は理由を入力してください。",

    warningTitles2: "詳細は info@egeetouch.com までお問い合わせください",
    warningTitles3:
      "*IAMのサブスクリプションには eGeeTouch スマート南京錠は含まれません。南京錠は別売りです。",

    changingPlanNoti: "プラン変更中です。ページを閉じないでください。",
    switchSuccessNoti: "プラン変更が完了しました。ページを更新します…",
    switchFailedNoti:
      "プラン変更に失敗しました。しばらくしてから再度お試しください。",
    paymentErrorNotif:
      "エラーが発生しました。しばらくしてから再度お試しください。",
    invalidCardNotif: "カード情報が無効です。もう一度お試しください。",
    subscriptionSuccessNoti: "お申し込みが完了しました。ありがとうございます。",
    paymentFailNotif1: "お支払いが",
    paymentFailNotif2: "失敗しました。しばらくしてから再度お試しください。",
    cardDeclinedNotif1: "カードが",
    cardDeclinedNotif2: "拒否されました",
    invalidCredentialsNotif: "カード情報が正しいかご確認ください。",
    remarkFree: "個人利用（無料）",
    remarkStarter: "アプリ登録数最大4、1台のロックに登録できるNFC数最大4",
    remarkEachLockUpTo:
      "アプリ登録数最大{m}、1台のロックに登録できるNFC数最大{o}",
  },
});

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

// ------------- numeric plan → column index mapping (21..27 -> 0..6) -------------
const PLAN_NUMBER_TO_COL = { 21: 0, 22: 1, 23: 2, 24: 3, 25: 4, 26: 5, 27: 6 };

/** ---------- NEW helpers: label aliasing + robust plan meta resolver ---------- */
const PLAN_LABEL_ALIASES = {
  free: "Free",
  starter: "Starter New", // UI header is "Starter", mapper expects "Starter New"
  starternew: "Starter New",
  lockfocus: "Lock Focus",
  "lock focus": "Lock Focus",
  prolocks: "Pro Locks",
  "pro locks": "Pro Locks",
  userfocus: "User Focus",
  "user focus": "User Focus",
  prousers: "Pro Users",
  "pro users": "Pro Users",
  largeapp: "Large App",
  "large app": "Large App",
};

function normalizeKey(s) {
  return String(s || "")
    .toLowerCase()
    .replace(/\s+/g, "");
}

/**
 * Resolve UI label -> planToNumber meta and normalize property names
 * so we always get the correct monthly/annual price IDs & prices.
 */
function resolvePlan(btnClick) {
  const key = normalizeKey(btnClick);
  const canonicalLabel = PLAN_LABEL_ALIASES[key] || btnClick;
  const raw = planToNumber(canonicalLabel);

  const planIdMonthly =
    raw.planId || raw.monthlyPlanId || raw.priceIdMonthly || raw.priceId;
  const planIdAnnual =
    raw.annualPlanId || raw.planIdAnnual || raw.priceIdAnnual;

  const planPriceMonthly = raw.planPrice ?? raw.monthlyPrice;
  const planPriceAnnual = raw.planPriceAnnual ?? raw.annualPrice;

  return {
    ...raw,
    canonicalLabel,
    planIdMonthly,
    planIdAnnual,
    planPriceMonthly,
    planPriceAnnual,
  };
}

class StripeBtnNew extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      planSelected: "Free",
      planId: egeeTouchPlans.egeeTouchplan21.planId,
      planPrice: "",
      planPriceDisplay: "",
      loading: false,
      _notificationSystem: null,
      errorMessage: "",
      existingPlan: false,
      stripeSubscriptionId: null,
      openCarousel: false,
      redirect: false,
      subscribedBefore: false,
      trialEnded: false,
      trialEndDate: undefined,
      currentPlan: "",
      currentPlanType: "",
      countryCode: "",
      annualPayment: false,
      currentLanguage: "",
      existingSuperAdminStatus: false,
      existingAccount: false,
      userName: "",
      userCompany: "",
      showCancellationForm: false,
      selectedReasons: [],
      otherReasons: false,
      statedReason: "",
      selectedSubDuration: "",
      selectedRating: "",
      additionalFeedback: "",
      cancellationFormError: "",
      // numeric plan from Firebase
      paymentPlanNumber: undefined,
      currentPlanIndex: undefined,
      lang: "en",
      cardComplete: false,
      cardError: "",
    };

    this.showLoadingNoti = this.showLoadingNoti.bind(this);
    this.cancelSub = this.cancelSub.bind(this);
    this.handleSubCancellation = this.handleSubCancellation.bind(this);
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.handleReasonsSelection = this.handleReasonsSelection.bind(this);
    this.handleOtherReasons = this.handleOtherReasons.bind(this);
    this.handleReasonChange = this.handleReasonChange.bind(this);
    this.handleSubDurationSelection = this.handleSubDurationSelection.bind(
      this
    );
    this.handleRatingSelection = this.handleRatingSelection.bind(this);
    this.handleAdditionalFeedbackChange = this.handleAdditionalFeedbackChange.bind(
      this
    );
    this.handleSubmitCancellationForm = this.handleSubmitCancellationForm.bind(
      this
    );
    this.submit = this.submit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.popupFormCard = this.popupFormCard.bind(this);
    this.popupFormTrial = this.popupFormTrial.bind(this);
    this.showSubscriptionSuccess = this.showSubscriptionSuccess.bind(this);
    this.showPaymentFailed = this.showPaymentFailed.bind(this);
    this.showSwitchSuccess = this.showSwitchSuccess.bind(this);
    this.showSwitchFailed = this.showSwitchFailed.bind(this);
    this.handleRemoveBtn = this.handleRemoveBtn.bind(this);
    this.handlePopupOpen = this.handlePopupOpen.bind(this);
    this.handlePopupClose = this.handlePopupClose.bind(this);
    this.getPlanPrice = this.getPlanPrice.bind(this);
    this.getPlanName = this.getPlanName.bind(this);
    this.toggleBilling = this.toggleBilling.bind(this);
    this.handleSubscriptionButtonClick = this.handleSubscriptionButtonClick.bind(
      this
    );
  }

  containerRef = React.createRef();

  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });

    if (this.containerRef.current) {
      this.containerRef.current.scrollLeft =
        this.containerRef.current.scrollWidth / 2 -
        this.containerRef.current.clientWidth / 2;
    }

    // Geo
    ipapi.location((callback) => {
      if (callback?.country_code === "JP" || callback?.country_code === "GB") {
        customLog(callback.country_code);
        this.setState({ countryCode: callback.country_code });
      }
    });

    // Load current account/payment → set numeric plan + type
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid)
      .once("value")
      .then((ss) => {
        if (ss.exists()) {
          const data = ss.val();
          const pay = data.payment || {};
          const subId = pay.stripeSubscriptionId || null;
          const trialEndDate = pay.trialEndDate;

          if (pay.isPaymentValid) {
            this.setState({
              specialTrialMode: !!pay.specialTrialMode,
              trialEndDate: pay.trialEndDate,
              stripeSubscriptionId: subId,
              existingPlan: true,
              currentPlan: pay.planName || pay.plan,
              currentPlanType: pay.planType,
              paymentPlanNumber: Number.isInteger(pay.plan)
                ? pay.plan
                : undefined,
              annualPayment: pay.planType === "ANNUAL",
            });
          } else {
            this.setState({ subscribedBefore: true });
          }

          if (trialEndDate <= Math.floor(Date.now() / 1000)) {
            this.setState({ trialEnded: true });
          }

          this.setState({ trialEndDate });
        }
      })
      .catch((err) => customLog(err));

    // Language listener
    if (auth.currentUser !== null) {
      this.langRef = fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language");

      this.langRef.on("value", (snapshot) => {
        const langValue = snapshot.val() === "ja" ? "ja" : "en";

        // IMPORTANT: update state so React re-renders
        this.setState({ currentLanguage: langValue, lang: langValue });

        // also set the localizationStrings language
        localizationStrings.setLanguage(langValue);
      });
    }

    // existingAccount / super admin checks
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((user) => {
          let userId = user.key;
          fire
            .database()
            .ref("groupAccounts")
            .child(userId)
            .child("members")
            .once("value")
            .then((childSnapshot) => {
              childSnapshot.forEach((member) => {
                let memberVal = member.val();
                if (memberVal.memberEmail === auth.currentUser.email) {
                  if (memberVal.isSuperAdmin === true) {
                    this.setState({
                      existingSuperAdminStatus: true,
                      existingAccount: true,
                    });
                  } else {
                    this.setState({ existingAccount: true });
                  }
                }
              });
            });
        });
      });

    // user info
    fire
      .database()
      .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          const data = snapshot.val();
          this.setState({
            userName: data.name,
            userCompany: data.company,
          });
        }
      });
  }

  componentWillUnmount() {
    if (this.langRef) this.langRef.off();
  }

  // componentWillMount() {
  //   // Geo
  //   ipapi.location(async (callback) => {
  //     if (callback?.country_code === "JP" || callback?.country_code === "GB") {
  //       customLog(callback.country_code);
  //       this.setState({ countryCode: callback.country_code });
  //     }
  //   });

  //   // Load current account/payment → set numeric plan + type
  //   fire
  //     .database()
  //     .ref("groupAccounts/" + auth.currentUser.uid)
  //     .once("value")
  //     .then((ss) => {
  //       if (ss.exists()) {
  //         const data = ss.val();
  //         const pay = data.payment || {};
  //         const subId = pay.stripeSubscriptionId || null;
  //         const trialEndDate = pay.trialEndDate;

  //         if (pay.isPaymentValid) {
  //           this.setState({
  //             specialTrialMode: !!pay.specialTrialMode,
  //             trialEndDate: pay.trialEndDate,
  //             stripeSubscriptionId: subId,
  //             existingPlan: true,
  //             currentPlan: pay.planName || pay.plan, // keep old name if present
  //             currentPlanType: pay.planType,
  //             paymentPlanNumber: Number.isInteger(pay.plan)
  //               ? pay.plan
  //               : undefined,
  //             annualPayment: pay.planType === "ANNUAL",
  //           });
  //         } else {
  //           this.setState({ subscribedBefore: true });
  //         }

  //         if (trialEndDate <= Math.floor(Date.now() / 1000)) {
  //           this.setState({ trialEnded: true });
  //         }

  //         this.setState({ trialEndDate });
  //       }
  //     })
  //     .catch((err) => customLog(err));

  //   // Language
  //   if (auth.currentUser !== null) {
  //     fire
  //       .database()
  //       .ref("userSettings")
  //       .child(auth.currentUser.uid)
  //       .child("language")
  //       .on("value", (snapshot) => {
  //         this.setState({ currentLanguage: snapshot.val() });
  //       });
  //   }

  //   // existingAccount / super admin checks
  //   fire
  //     .database()
  //     .ref("groupAccounts")
  //     .once("value")
  //     .then((snapshot) => {
  //       snapshot.forEach((user) => {
  //         let userId = user.key;
  //         fire
  //           .database()
  //           .ref("groupAccounts")
  //           .child(userId)
  //           .child("members")
  //           .once("value")
  //           .then((childSnapshot) => {
  //             childSnapshot.forEach((member) => {
  //               let memberVal = member.val();
  //               if (memberVal.memberEmail === auth.currentUser.email) {
  //                 if (memberVal.isSuperAdmin === true) {
  //                   this.setState({
  //                     existingSuperAdminStatus: true,
  //                     existingAccount: true,
  //                   });
  //                 } else {
  //                   this.setState({ existingAccount: true });
  //                 }
  //               }
  //             });
  //           });
  //       });
  //     });

  //   // user info
  //   fire
  //     .database()
  //     .ref("registeredIndustrialUsersOnPlatform/" + auth.currentUser.uid)
  //     .once("value")
  //     .then((snapshot) => {
  //       if (snapshot.exists()) {
  //         const data = snapshot.val();
  //         this.setState({
  //           userName: data.name,
  //           userCompany: data.company,
  //         });
  //       }
  //     });
  // }

  // -------------------- unified pricing label resolver (21–27) --------------------
  getPlanPrice(planNumber, annualPayment) {
    // [monthlyLabel, annualLabel, monthlyDiscountedLabel, annualDiscountedLabel]
    const M = {
      21: [
        localizationStrings.freePackagePlanPrice,
        localizationStrings.freePackagePlanPriceAnnual,
        localizationStrings.freePackagePlanPriceDiscount,
        localizationStrings.freePlanPriceAnnualDiscount,
      ],
      22: [
        localizationStrings.starterNewPlanPrice,
        localizationStrings.starterNewPlanPriceAnnual,
        localizationStrings.starterNewPlanPriceDiscount,
        localizationStrings.starterNewPlanPriceAnnualDiscount,
      ],
      23: [
        localizationStrings.lockFocusPlanPrice,
        localizationStrings.lockFocusPlanPriceAnnual,
        localizationStrings.lockFocusPlanPriceDiscount,
        localizationStrings.lockFocusPlanPriceAnnualDiscount,
      ],
      24: [
        localizationStrings.proLocksPlanPrice,
        localizationStrings.proLocksPlanPriceAnnual,
        localizationStrings.proLocksPlanPriceDiscount,
        localizationStrings.proLocksPlanPriceAnnualDiscount,
      ],
      25: [
        localizationStrings.userFocusPlanPrice,
        localizationStrings.userFocusPlanPriceAnnual,
        localizationStrings.userFocusPlanPriceDiscount,
        localizationStrings.userFocusPlanPriceAnnualDiscount,
      ],
      26: [
        localizationStrings.proUsersPlanPrice,
        localizationStrings.proUsersPlanPriceAnnual,
        localizationStrings.proUsersPlanPriceDiscount,
        localizationStrings.proUsersPlanPriceAnnualDiscount,
      ],
      27: [
        localizationStrings.largeAppPlanPrice,
        localizationStrings.largeAppPlanPriceAnnual,
        localizationStrings.largeAppPlanPriceDiscount,
        localizationStrings.largeAppPlanPriceAnnualDiscount,
      ],
    };
    const row = M[planNumber];
    if (!row) return "";
    // Show discounted label to align with toggle + Stripe price IDs
    return annualPayment ? row[3] : row[2];
  }

  showLoadingNoti() {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{localizationStrings.changingPlanNoti}</div>,
      level: "warning",
      position: "tc",
      autoDismiss: 5,
    });
  }
  showSwitchSuccess() {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{localizationStrings.subscriptionSuccessNoti}</div>,
      level: "success",
      position: "tc",
      autoDismiss: 5,
    });
    setTimeout(() => window.location.reload(), 5000);
  }
  showSwitchFailed() {
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{localizationStrings.switchFailedNoti}</div>,
      level: "error",
      position: "tc",
      autoDismiss: 10,
    });
  }

  getPlanName(planNumber) {
    if (planNumber === 21) return localizationStrings.freePackage;
    if (planNumber === 22) return localizationStrings.starterNewPackage;
    if (planNumber === 23) return localizationStrings.lockFocusPackage;
    if (planNumber === 24) return localizationStrings.proLocksPackage;
    if (planNumber === 25) return localizationStrings.userFocusPackage;
    if (planNumber === 26) return localizationStrings.proUsersPackage;
    if (planNumber === 27) return localizationStrings.largeAppPackage;
    return "";
  }

  openModal(btnClick) {
    // If user is on Free trial, treat "change plan" as a purchase:
    //  - prefill plan meta (incl. monthly/annual toggle)
    //  - open the card popup so they must pay now
    if (this.state.specialTrialMode) {
      const meta = resolvePlan(btnClick);
      this.setState({
        planSelected: meta.canonicalLabel,
        planSelectedNumber: meta.planNumber,
        planId: this.state.annualPayment
          ? meta.planIdAnnual
          : meta.planIdMonthly,
        planPrice: this.state.annualPayment
          ? meta.planPriceAnnual
          : meta.planPriceMonthly,
        planPriceDisplay: this.getPlanPrice(
          meta.planNumber,
          this.state.annualPayment
        ),
        open: true, // show popup
        showWarning: false, // ensure no warning
      });
      return;
    }

    // Normal (already-paid) path stays the same
    if (this.state.existingPlan) {
      const changeTitle = "Change Plan";
      const changeMsg = `Do you want to switch to ${btnClick} plan ?`;
      const changeBtn = [
        {
          label: "Confirm",
          onClick: () => {
            this.showLoadingNoti();

            const meta = resolvePlan(btnClick);
            const planType = this.state.annualPayment ? "ANNUAL" : "MONTHLY";
            const newPlanId = this.state.annualPayment
              ? meta.planIdAnnual
              : meta.planIdMonthly;

            const dataToChange = {
              subId: this.state.stripeSubscriptionId,
              planId: newPlanId,
            };
            const dataToUpdate = {
              plan: meta.planNumber,
              planType,
              maxTags: meta.maxTags,
              maxUsers: meta.maxUsers,
              maxLocks: meta.maxLocks,
              maxMulti: meta.maxMulti,
              currentPlanId: newPlanId,
            };
            changePlan(dataToChange, dataToUpdate, (ok) =>
              ok ? this.showSwitchSuccess() : this.showSwitchFailed()
            );
          },
        },
        { label: "Close", onClick: () => false },
      ];
      showConfirmAlert(changeTitle, changeMsg, changeBtn);
    } else {
      // buying path (first-time purchase)
      const meta = resolvePlan(btnClick);
      this.setState({
        planSelected: meta.canonicalLabel,
        planSelectedNumber: meta.planNumber,
        planId: this.state.annualPayment
          ? meta.planIdAnnual
          : meta.planIdMonthly,
        planPrice: this.state.annualPayment
          ? meta.planPriceAnnual
          : meta.planPriceMonthly,
        planPriceDisplay: this.getPlanPrice(
          meta.planNumber,
          this.state.annualPayment
        ),
      });

      if (this.state.existingAccount) {
        this.setState({
          open: this.state.existingSuperAdminStatus ? true : false,
          showWarning: this.state.existingSuperAdminStatus ? false : true,
        });
      } else {
        this.setState({ open: true });
      }
    }
  }

  closeModal() {
    this.setState({
      open: false,
      loading: false,
      cardComplete: false,
      cardError: "",
    });

    // Optional: clear inputs (prevents old values)
    const name = document.getElementById("creditCardName");
    const addr = document.getElementById("creditCardAddr");
    if (name) name.value = "";
    if (addr) addr.value = "";
  }

  showPaymentFailed() {
    this.setState({ loading: false });
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {localizationStrings.paymentFailNotif1}
          <b>{localizationStrings.paymentFailNotif2}</b>
        </div>
      ),
      level: "error",
      position: "tc",
      autoDismiss: 10,
    });
  }
  showCardDeclined() {
    this.setState({ loading: false });
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          {localizationStrings.cardDeclinedNotif1}
          <b>{localizationStrings.cardDeclinedNotif2}</b> !
        </div>
      ),
      level: "error",
      position: "tc",
      autoDismiss: 10,
    });
  }
  showCardInvalidCredentials() {
    this.setState({ loading: false });
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{localizationStrings.invalidCredentialsNotif}</div>,
      level: "error",
      position: "tc",
      autoDismiss: 10,
    });
  }
  showSubscriptionSuccess() {
    const notification = this.state._notificationSystem;
    notification.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>Subscription successful ! Thank you, we hope you Enjoy</div>
      ),
      level: "success",
      position: "tc",
      autoDismiss: 3,
    });
  }
  showPaymentError() {
    const notification = this.state._notificationSystem;
    notification.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: <div>{localizationStrings.paymentErrorNotif}</div>,
      level: "error",
      position: "tc",
      autoDismiss: 5,
    });
  }

  async submit(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();

    // ✅ prevent double submit
    if (this.state.loading) return;

    // ✅ FREE plan trial path (no Stripe) — only for brand‑new users on FREE plan
    const isFreePlan =
      Number(this.state.planSelectedNumber) === 21 ||
      this.state.planSelected === egeeTouchPlans.egeeTouchplan21.planName;

    const hasActiveSub = this.state.existingPlan === true;
    if (!hasActiveSub && isFreePlan) {
      this.setState({ loading: true });
      try {
        const meta = resolvePlan(this.state.planSelected);
        const planNumber = meta.planNumber;
        const planType = this.state.annualPayment ? "ANNUAL" : "MONTHLY";
        const planId = this.state.annualPayment
          ? meta.planIdAnnual
          : meta.planIdMonthly;

        const maxUser = meta.maxUsers;
        const maxLock = meta.maxLocks;
        const maxTag = meta.maxTags;
        const maxMulti = meta.maxMulti;

        let today;
        getToday((response) => (today = response));

        const currentTime = Math.floor(Date.now() / 1000);
        const trialEndDate = currentTime + 1209600;

        const memberName =
          this.state.userName ||
          auth.currentUser?.displayName ||
          auth.currentUser?.email ||
          "User";

        const dbGroupMembers = {
          isAdmin: true,
          isSuperAdmin: true,
          memberAddedOn: currentTime,
          memberName,
          memberEmail: auth.currentUser.email,
          memberUid: "push.key",
        };

        const dbPayments = {
          currentPaymentType: "",
          currentPlanId: planId,
          currentRedemptionActiveCode: "",
          dateLastPayment: "",
          isPaymentValid: true,
          maxUsers: maxUser,
          maxTags: maxTag,
          maxLocks: maxLock,
          maxMulti: maxMulti,
          plan: planNumber,
          planType: planType,
          specialTrialMode: true,
          startMonthlyCycle: today,
          startedOn: currentTime,
          trialStartDate: currentTime,
          trialEndDate: trialEndDate,
          onTrialPeriod: true,
          stripeSubscriptionId: "",
          stripeCustomerId: "",
          cardName: "",
          billingAddr: "",
          cardLastFourDigit: "",
          cardExp: "",
        };

        const groupAccSchema = {
          created_on: currentTime,
          groupName: "My First Group",
          payment: dbPayments,
        };

        await pushNewGroupAccounts(dbGroupMembers, groupAccSchema, (ok) => {
          if (ok) this.showSubscriptionSuccess();
        });

        this.setState({ loading: false });
        this.closeModal();
        setTimeout(() => (window.location.href = "/dashboard"), 5000);
        return;
      } catch (e) {
        customLog(e);
        this.setState({ loading: false });
        this.showPaymentError();
        return;
      }
    }
    if (!this.state.cardComplete) {
      this.setState({ loading: false });
      this.showCardInvalidCredentials(); // or showPaymentError()
      return;
    }

    // ✅ Payment path (existingAccount)
    this.setState({ loading: true });

    try {
      const creditCardName =
        document.getElementById("creditCardName")?.value?.trim() || "";
      const creditCardAddr =
        document.getElementById("creditCardAddr")?.value?.trim() || "";

      // ✅ basic front validation (because you weren't using <form>)
      if (!creditCardName || !creditCardAddr) {
        this.setState({ loading: false });
        this.showCardInvalidCredentials();
        return;
      }

      // ✅ IMPORTANT: pass name + address into the payment method
      const result = await this.props.stripe.createPaymentMethod({
        type: "card",
        card: this.props.elements.getElement(CardElement),
        billing_details: {
          name: creditCardName,
          address: { line1: creditCardAddr },
        },
      });

      // ✅ DO NOT close modal here. Only close on success.
      if (result.error) {
        const code = result.error.code;

        if (
          code === "invalid_number" ||
          code === "incomplete_number" ||
          code === "incomplete_expiry" ||
          code === "incomplete_cvc" ||
          code === "invalid_expiry_year" ||
          code === "invalid_expiry_month" ||
          code === "invalid_cvc"
        ) {
          this.showCardInvalidCredentials();
        } else if (code === "card_declined") {
          this.showCardDeclined();
        } else {
          this.showPaymentError();
        }

        this.setState({ loading: false });
        return;
      }

      const dataToPost = {
        paymentMethodId: result.paymentMethod.id,
        email: auth.currentUser.email,
        planName: this.state.planSelected,
        planPrice: this.state.planPrice,
        planType: this.state.annualPayment ? "year" : "month",
        planId: this.state.planId,
        currentUid: auth.currentUser.uid,
        language: this.state.currentLanguage || "en",
      };

      planSubscription(dataToPost, async (callback) => {
        try {
          if (callback === "card_declined") {
            this.showCardDeclined();
            this.setState({ loading: false });
            return;
          }
          if (callback === "incorrect_number") {
            this.showCardInvalidCredentials();
            this.setState({ loading: false });
            return;
          }
          if (callback === false) {
            this.showPaymentFailed();
            this.setState({ loading: false });
            return;
          }

          if (callback?.requiresAction && callback?.clientSecret) {
            const confirm =
              callback.intentType === "setup"
                ? await this.props.stripe.confirmCardSetup(
                    callback.clientSecret
                  )
                : await this.props.stripe.confirmCardPayment(
                    callback.clientSecret
                  );

            if (confirm.error) {
              this.showCardDeclined();
              this.setState({ loading: false });
              return;
            }
            // 3DS authentication succeeded — fall through to the success path below
          } else if (callback?.message !== "Subscribed") {
            this.showPaymentError();
            this.setState({ loading: false });
            return;
          }

          // ✅ success
          const stripeSubId = callback.response.id;
          const stripeCustomerId = callback.response.customer;

          const meta = resolvePlan(this.state.planSelected);
          const planNumber = meta.planNumber;
          const planType = this.state.annualPayment ? "ANNUAL" : "MONTHLY";
          const planId = this.state.annualPayment
            ? meta.planIdAnnual
            : meta.planIdMonthly;

          const maxUser = meta.maxUsers;
          const maxLock = meta.maxLocks;
          const maxTag = meta.maxTags;
          const maxMulti = meta.maxMulti;

          const paidDate = callback.response.current_period_start;
          const customerId = callback.response.customer;
          const planSelected = this.state.planSelected;

          const cardLastFour = result.paymentMethod.card.last4;
          const cardExpMonth = result.paymentMethod.card.exp_month;
          const cardExpYear = result.paymentMethod.card.exp_year;
          const cardExp = `${cardExpMonth}/${cardExpYear}`;

          let today;
          getToday((response) => (today = response));

          const memberName =
            this.state.userName ||
            auth.currentUser?.displayName ||
            auth.currentUser?.email ||
            "User";

          const dbGroupMembers = {
            isAdmin: true,
            isSuperAdmin: true,
            memberAddedOn: paidDate,
            memberName,
            memberEmail: auth.currentUser.email,
            memberUid: "push.key",
          };

          let dbPayments = {
            currentPaymentType: "STRIPE",
            currentPlanId: planId,
            currentRedemptionActiveCode: "",
            dateLastPayment: paidDate,
            isPaymentValid: true,
            maxUsers: maxUser,
            maxTags: maxTag,
            maxLocks: maxLock,
            maxMulti: maxMulti,
            plan: planNumber,
            planType: planType,
            specialTrialMode: false,
            startMonthlyCycle: today,
            startedOn: paidDate,
            trialEndDate: null,
            onTrialPeriod: false,
            stripeSubscriptionId: stripeSubId,
            stripeCustomerId: stripeCustomerId,
            cardName: creditCardName,
            billingAddr: creditCardAddr,
            cardLastFourDigit: cardLastFour,
            cardExp: cardExp,
          };

          if (this.state.trialEndDate !== undefined) {
            dbPayments.trialEndDate = this.state.trialEndDate;
          }
          if (this.state.trialEnded === true) {
            dbPayments.onTrialPeriod = false;
          }

          const groupAccSchema = {
            created_on: paidDate,
            groupName: "My First Group",
            payment: dbPayments,
          };

          // remove old redeemed code if any
          fire
            .database()
            .ref("groupAccounts")
            .child(auth.currentUser.uid)
            .child("payment")
            .child("redeemedRedemptionCode")
            .once("value")
            .then((snap) => {
              if (snap.exists()) snap.ref.remove();
            });

          if (this.state.subscribedBefore) {
            const dataToUpdate = {
              currentPaymentType: "STRIPE",
              currentPlanId: planId,
              currentRedemptionActiveCode: "",
              stripeCustomerId: stripeCustomerId,
              stripeSubscriptionId: stripeSubId,
              cardName: creditCardName,
              billingAddr: creditCardAddr,
              cardLastFourDigit: cardLastFour,
              cardExp: cardExp,
              dateLastPayment: paidDate,
              isPaymentValid: true,
              specialTrialMode: false,
              maxUsers: maxUser,
              plan: planNumber,
              planType: planType,
              maxMulti: maxMulti,
              maxTags: maxTag,
              maxLocks: maxLock,
            };

            await updateExistingGroupAccounts(dataToUpdate, async (ok) => {
              if (ok) {
                this.showSubscriptionSuccess();
                await updateUserDetails(paidDate, customerId, planSelected);
                this.setState({
                  loading: false,
                  stripeSubscriptionId: stripeSubId,
                });
                this.closeModal(); // ✅ close only on success
              } else {
                this.setState({ loading: false });
                this.showPaymentError();
              }
            });
          } else {
            await pushNewGroupAccounts(
              dbGroupMembers,
              groupAccSchema,
              async (ok) => {
                if (ok) {
                  this.showSubscriptionSuccess();
                  await updateUserDetails(paidDate, customerId, planSelected);
                  this.setState({
                    loading: false,
                    stripeSubscriptionId: stripeSubId,
                  });
                  this.closeModal(); // ✅ close only on success
                } else {
                  this.setState({ loading: false });
                  this.showPaymentError();
                }
              }
            );
          }
        } catch (e) {
          customLog(e);
          this.setState({ loading: false });
          this.showPaymentError();
        }
      });
    } catch (err) {
      customLog(err);
      this.setState({ loading: false });
      this.showPaymentError();
    }
  }

  handleSubCancellation() {
    this.setState({ showCancellationForm: true });
  }
  handleCloseModal() {
    this.setState({
      showCancellationForm: false,
      selectedReasons: [],
      otherReasons: false,
      statedReason: "",
      selectedSubDuration: "",
      selectedRating: "",
      additionalFeedback: "",
      cancellationFormError: "",
    });
  }
  handleReasonsSelection(event) {
    const { value, checked } = event.target;
    const { selectedReasons } = this.state;
    let updatedReasons = checked
      ? [...selectedReasons, value]
      : selectedReasons.filter((reason) => reason !== value);

    updatedReasons.sort((a, b) => {
      const indexA = parseInt(
        document
          .querySelector(`input[value="${a}"]`)
          .name.replace("reason", ""),
        10
      );
      const indexB = parseInt(
        document
          .querySelector(`input[value="${b}"]`)
          .name.replace("reason", ""),
        10
      );
      return indexA - indexB;
    });

    this.setState({ selectedReasons: updatedReasons });
  }
  handleOtherReasons(event) {
    this.setState({ otherReasons: event.target.checked, statedReason: "" });
  }
  handleReasonChange(event) {
    this.setState({ statedReason: event.target.value });
  }
  handleSubDurationSelection(event) {
    this.setState({ selectedSubDuration: event.target.value });
  }
  handleRatingSelection(event) {
    this.setState({ selectedRating: event.target.value });
  }
  handleAdditionalFeedbackChange(event) {
    this.setState({ additionalFeedback: event.target.value });
  }
  handleSubmitCancellationForm() {
    const {
      selectedReasons,
      selectedSubDuration,
      selectedRating,
      otherReasons,
      statedReason,
    } = this.state;

    if (
      selectedReasons.length === 0 ||
      selectedSubDuration === "" ||
      selectedRating === ""
    ) {
      this.setState({
        cancellationFormError: localizationStrings.cancellationFormIncomplete,
      });
      return;
    } else if (otherReasons === true && statedReason === "") {
      this.setState({
        cancellationFormError: localizationStrings.cancellationFormOtherReason,
      });
      return;
    } else {
      this.setState({ cancellationFormError: "" });
    }

    this.setState({
      showCancellationForm: false,
      cancellationFormError: "",
    });
    this.cancelSub();
  }

  cancelSub() {
    if (this.state.existingPlan) {
      const delTitle = localizationStrings.deleteTitleTitle;
      const delMessage = localizationStrings.deleteMessageTitle;
      const delButton = [
        {
          label: localizationStrings.confirmTitle,
          onClick: () => {
            this.setState({ loading: true });
            const details = {
              subId: this.state.stripeSubscriptionId,
              uid: auth.currentUser.uid,
              language: this.state.currentLanguage || "en",
            };

            cancelSub(details, (response) => {
              if (response.ok) {
                const delConfirmTitle =
                  localizationStrings.subscriptionCancelled;
                const delConfirmMessage =
                  localizationStrings.subscriptionCancelledMsg;
                const delConfirmButton = [
                  {
                    label: localizationStrings.close,
                    onClick: () => {
                      window.location.reload();
                      return false;
                    },
                  },
                ];

                const {
                  selectedReasons,
                  statedReason,
                  selectedSubDuration,
                  selectedRating,
                  additionalFeedback,
                } = this.state;

                const updatedReasons = selectedReasons.map((reason) =>
                  reason === "Others"
                    ? `Others - ${statedReason || "Unspecified"}`
                    : reason
                );
                const databaseRef = fire
                  .database()
                  .ref("subscriptionCancellation-datacollection");
                const recordId = databaseRef.push().key;
                const recordData = {
                  userData: {
                    email: auth.currentUser.email,
                    name: this.state.userName,
                    company: this.state.userCompany,
                  },
                  reasons: updatedReasons.reduce((acc, reason, index) => {
                    acc[index] = reason;
                    return acc;
                  }, {}),
                  subDuration: selectedSubDuration,
                  serviceRating: parseInt(selectedRating, 10),
                  feedback: additionalFeedback || "NIL",
                };

                databaseRef
                  .child(recordId)
                  .set(recordData)
                  .catch(() => {});
                showConfirmAlert(
                  delConfirmTitle,
                  delConfirmMessage,
                  delConfirmButton
                );

                this.setState({
                  stripeSubscriptionId: null,
                  existingPlan: false,
                  loading: false,
                  selectedReasons: [],
                  otherReasons: false,
                  statedReason: "",
                  selectedSubDuration: "",
                  selectedRating: "",
                  additionalFeedback: "",
                });
              }
            });
          },
        },
        {
          label: localizationStrings.cancelTitle,
          onClick: () => {
            this.setState({
              selectedReasons: [],
              otherReasons: false,
              statedReason: "",
              selectedSubDuration: "",
              selectedRating: "",
              additionalFeedback: "",
            });
            return false;
          },
        },
      ];
      showConfirmAlert(delTitle, delMessage, delButton);
    } else {
      const noSubTitle = localizationStrings.oops;
      const noSubMessage = localizationStrings.noPlanError;
      const noSubBtn = [
        { label: localizationStrings.close, onClick: () => false },
      ];
      showConfirmAlert(noSubTitle, noSubMessage, noSubBtn);
    }
  }

  popupFormCard() {
    return (
      <div>
        <a className="close" onClick={this.closeModal}>
          &times;
        </a>

        <h2 id="planNameSelected">
          {this.getPlanName(this.state.planSelectedNumber)}
        </h2>

        <h3 id="planPriceSelected">
          {this.getPlanPrice(
            this.state.planSelectedNumber,
            this.state.annualPayment
          )}
        </h3>

        {/* ✅ Required validation works only with a form submit */}
        <form onSubmit={this.submit}>
          <input
            className={"stripeBtn-inputText"}
            type="text"
            id="creditCardName"
            placeholder={localizationStrings.nameOnCardTitle}
            required
          />

          <input
            className={"stripeBtn-inputText"}
            type="text"
            id="creditCardAddr"
            placeholder={localizationStrings.billingAddressTitle}
            required
          />

          <div id="planSelectedCredentialKey">
            <CardElement
              options={{
                hidePostalCode: true,
                style: { base: { fontSize: "18px" } },
              }}
              onChange={(e) => {
                this.setState({
                  cardComplete: !!e.complete,
                  cardError: e.error ? e.error.message : "",
                });
              }}
            />
            {this.state.cardError && (
              <div className="error" style={{ color: "red", marginTop: 8 }}>
                {this.state.cardError}
              </div>
            )}
          </div>

          <button
            id="paymentConfirmBtn"
            type="submit"
            disabled={this.state.loading || !this.state.cardComplete}
            title={
              !this.state.cardComplete ? "Please complete card details" : ""
            }
          >
            {this.state.loading
              ? "Processing..."
              : localizationStrings.submitButton}
          </button>
        </form>
      </div>
    );
  }

  popupFormTrial() {
    return (
      <div>
        <a className="close" onClick={this.closeModal}>
          &times;
        </a>
        <h2 id="planNameSelected">
          {this.getPlanName(this.state.planSelectedNumber)}
        </h2>
        <h3 id="planPriceSelected">
          {this.getPlanPrice(
            this.state.planSelectedNumber,
            this.state.annualPayment
          )}
        </h3>

        <div id="planSelectedCredentialKey">
          <h4 className="boldFont">{localizationStrings.trialPopupTitle}</h4>
          <br />
          <p className="lightFont">
            {localizationStrings.trialPopupDescription_1}
            <span className={"boldFont"}>
              {localizationStrings.trialPopupDescription_2}
            </span>
            {this.state.currentLanguage === "ja" ? <br /> : ""}
            {localizationStrings.trialPopupDescription_3}
            <br />
            {localizationStrings.trialPopupDescription1}
          </p>
        </div>
        <button id="paymentConfirmBtn" onClick={this.submit}>
          {localizationStrings.trialButton}
        </button>
      </div>
    );
  }

  handleRemoveBtn() {
    fire
      .database()
      .ref("groupAccounts")
      .once("value")
      .then((snapshot) => {
        snapshot.forEach((user) => {
          let userId = user.key;
          fire
            .database()
            .ref("groupAccounts")
            .child(userId)
            .child("members")
            .once("value")
            .then((childSnapshot) => {
              childSnapshot.forEach((member) => {
                let memberVal = member.val();
                if (memberVal.memberEmail === auth.currentUser.email) {
                  let memberUid = memberVal.memberUid;
                  fire
                    .database()
                    .ref("groupAccounts")
                    .child(userId)
                    .child("members")
                    .child(memberUid)
                    .remove();

                  this.setState({
                    open: true,
                    showWarning: false,
                    existingAccount: false,
                  });
                }
              });
            });
        });
      });

    fire
      .database()
      .ref("userLocks")
      .child(auth.currentUser.uid)
      .remove();
    fire
      .database()
      .ref("retractableSharingRegistry")
      .child(auth.currentUser.uid)
      .remove();
    fire
      .database()
      .ref("MyAdminLocks")
      .child(auth.currentUser.uid)
      .remove();
    fire
      .database()
      .ref("MyShareHistory")
      .child(auth.currentUser.uid)
      .remove();
    fire
      .database()
      .ref("userFriendListIndustrial")
      .child(auth.currentUser.uid)
      .remove();
  }

  handlePopupOpen() {
    this.setState({ showWarning: true });
  }
  handlePopupClose() {
    this.setState({ showWarning: false });
  }

  toggleBilling(checked) {
    this.setState({ annualPayment: checked });
  }

  handleSubscriptionButtonClick = (plan) => {
    this.openModal(plan);
  };

  render() {
    const { annualPayment } = this.state;
    const YEARLY_DISCOUNT = 0.12; // used by your price compare UI only
    const PLAN_KEYS = [
      "Free",
      "Starter",
      "Lock Focus",
      "Pro Locks",
      "User Focus",
      "Pro Users",
      "Large App",
    ];

    // ----- DATA FEEDS (as in your table) -----
    const headers = localizationStrings.planHeaders || [
      "Free",
      "Starter",
      "Lock Focus",
      "Pro Locks",
      "User Focus",
      "Pro Users",
      "Large App",
    ];

    const pricing = [
      ["$0.00", "$7.90", "$24.90", "$109.00", "$69.90", "$199.00", "$478.00"],
      ["", "$0.99", "$1.25", "$1.09", "$1.00", "$0.71", "$0.48"],
      [
        "Try for FREE",
        "Subscribe Now",
        "Subscribe Now",
        "Subscribe Now",
        "Subscribe Now",
        "Subscribe Now",
        "Subscribe Now",
      ],
    ];

    const lockValues = [2, 5, 25, 300, 4, 10, 500];
    const appUsers = [2, 4, 10, 25, 40, 180, 500];
    const nfcUsers = [2, 4, 10, 75, 30, 100, 500];
    const multiValues = [0, 1, 2, 4, 2, 4, 8];

    // now safe to compute total
    const totalUsers = appUsers.map(
      (v, i) => (Number(v) || 0) + (Number(nfcUsers[i]) || 0)
    );

    // now build manageAndAdd (no crash)
    const manageAndAdd = [
      { label: localizationStrings.labelLock || "LOCK", values: lockValues },
      {
        label: localizationStrings.labelAppUsers || "App Users",
        values: appUsers,
      },
      {
        label: localizationStrings.labelNfcFobUsers || "NFC Fob Users",
        values: nfcUsers,
      },
      {
        label: localizationStrings.labelMultiApproval || "Multi Approval",
        values: multiValues,
      },
      {
        label: localizationStrings.labelRemarks || "Remarks",
        values: [
          localizationStrings.remarkFree ||
            "Mobile App Only <br> Free 14 days trial for IAM Web System <br> (No Credit Card Needed)",

          localizationStrings.remarkStarter ||
            "Entry Level and Pilot Testing.<br> Each lock can be accessed Up to 8 users",

          ...appUsers.slice(2).map((m, idx) => {
            const o = nfcUsers[idx + 2];
            const n = (Number(m) || 0) + (Number(o) || 0); // total users

            const tpl = localizationStrings.remarkEachLockUpTo;

            // 🇯🇵 Japanese → use {m} and {o}
            if (this.state.currentLanguage === "ja") {
              return tpl.replace("{m}", String(m)).replace("{o}", String(o));
            }

            // 🇺🇸 English (default) → use {n}
            return tpl.replace("{n}", String(n));
          }),
        ],
      },
    ];

    const colorClasses = [
      "entry-free",
      "entry-starter",
      "lock-focus",
      "pro-locks",
      "user-focus",
      "pro-users",
      "large-app",
    ];
    const columnGroups = [
      { title: "Entry", span: 2, className: "head-chip chip-entry" },
      {
        title: "More Lock - Less User",
        span: 2,
        className: "head-chip chip-lock",
      },
      {
        title: "More User - Less Lock",
        span: 2,
        className: "head-chip chip-user",
      },
      {
        title: "Large Application",
        span: 1,
        className: "head-chip chip-large",
      },
    ];
    const priceColorClass = (i) => {
      const map = [
        "price-blue",
        "price-red",
        "price-green",
        "price-purple",
        "price-pink",
        "price-gray",
        "price-dark",
      ];
      return map[i] || "price-gray";
    };

    const parseMoney = (str) =>
      Number(String(str).replace(/[^0-9.]/g, "")) || 0;
    const fmt = (n) =>
      n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

    const priceCells = pricing[0].map((p, i) => {
      const monthly = parseMoney(p);
      const annualOriginal = monthly * 12;
      const value = annualPayment
        ? annualOriginal * (1 - YEARLY_DISCOUNT)
        : monthly;
      const unit = annualPayment
        ? ` / ${localizationStrings.unitYear}`
        : ` / ${localizationStrings.unitMonth}`;
      const showCompare =
        annualPayment && i !== 0 && annualOriginal > 0 && YEARLY_DISCOUNT > 0;

      return {
        value: fmt(value),
        unit,
        color: priceColorClass(i),
        annualOriginal: fmt(annualOriginal),
        showCompare,
      };
    });

    const lowAsCells = pricing[1].map((p) => {
      if (!p) return "";
      const monthly = parseMoney(p);
      const value = annualPayment
        ? monthly * 12 * (1 - YEARLY_DISCOUNT)
        : monthly;
      const unitWord = annualPayment ? "Year" : "Month";
      return { text: `$${fmt(value)}`, unitWord };
    });

    // -------------------- resolve current plan index --------------------
    let currentPlanIndex = -1;

    if (Number.isInteger(this.state?.paymentPlanNumber)) {
      currentPlanIndex = PLAN_NUMBER_TO_COL[this.state.paymentPlanNumber] ?? -1;
    }

    if (currentPlanIndex < 0) {
      const normalize = (s) =>
        (s || "")
          .toString()
          .toLowerCase()
          .replace(/[\s_-]+/g, "");
      const headerKeys = headers.map((h) => normalize(h));
      const aliasToIndex = {
        free: 0,
        starter: 1,
        starternew: 1,
        lockfocus: 2,
        lock_focus: 2,
        prolocks: 3,
        pro_locks: 3,
        userfocus: 4,
        user_focus: 4,
        prousers: 5,
        pro_users: 5,
        largeapp: 6,
        large_application: 6,
      };
      const planNameFromState =
        this.state.currentPlan ??
        this.props.currentPlan ??
        (typeof sessionStorage !== "undefined"
          ? sessionStorage.currentPlan
          : null);

      if (planNameFromState) {
        const key = normalize(planNameFromState);
        const direct = headerKeys.indexOf(key);
        currentPlanIndex = direct >= 0 ? direct : aliasToIndex[key] ?? -1;
      }
    }

    return (
      <section className="m-top-10" key={this.state.lang}>
        <NotificationSystem ref="notificationSystem" style={style} />
        <Popup
          open={this.state.open}
          closeOnDocumentClick
          className="planPopup"
          onClose={this.closeModal}
        >
          {!this.state.existingPlan &&
          (Number(this.state.planSelectedNumber) === 21 ||
            this.state.planSelected === "Free" ||
            this.state.planSelected === egeeTouchPlans.egeeTouchplan21.planName)
            ? this.popupFormTrial()
            : this.popupFormCard()}
        </Popup>

        <div className="container-iam mx-auto">
          <div
            className="switchBtnWrapper"
            style={{ position: "relative", top: "20", margin: "10px 0 20px" }}
          >
            <section
              style={{
                marginLeft: "auto",
                marginRight: "auto",
                width: "80%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <span className="annualMonthlyTitles">
                {localizationStrings.monthlyTitle}
              </span>
              <Switch
                className="annualMonthlyBtn"
                onChange={this.toggleBilling}
                checked={annualPayment}
                offColor="#cbd5e1"
                onColor="#0d8cbf"
                uncheckedIcon={false}
                checkedIcon={false}
                height={20}
                width={44}
                handleDiameter={18}
              />
              <span className="annualMonthlyTitles">
                {localizationStrings.annualTitle}
              </span>
              <div className="saveMoreAlert">
                {localizationStrings.saveAmtTitle}
              </div>
            </section>
          </div>

          <div className="table-responsive newplanstable">
            <table className="table table-bordered align-middle">
              <thead>
                <tr>
                  <th rowSpan={5} className="th-iam"></th>
                  {columnGroups.map((g, idx) => (
                    <th key={idx} colSpan={g.span} className={g.className}>
                      {g.title}
                    </th>
                  ))}
                </tr>

                <tr>
                  {headers.map((head, i) => (
                    <th key={i} className="border-y-none">
                      {head}
                    </th>
                  ))}
                </tr>

                <tr>
                  {priceCells.map((pc, i) => (
                    <th key={`price-${i}`} className="border-y-none">
                      {pc.showCompare && (
                        <div className="price-compare">
                          <span className="price-old">
                            <sup>$</sup>
                            {pc.annualOriginal}
                          </span>
                          <span className="price-off">
                            (-{Math.round(YEARLY_DISCOUNT * 100)}%)
                          </span>
                        </div>
                      )}
                      <span className={`plan-price ${pc.color}`}>
                        <sup>$</sup>
                        {pc.value}
                        <sub>
                          <small>{pc.unit}</small>
                        </sub>
                      </span>
                    </th>
                  ))}
                </tr>

                {this.state.currentLanguage !== "ja" && (
                  <tr>
                    {lowAsCells.map((lc, i) => (
                      <td key={`low-${i}`} className="border-y-none">
                        {i === 0 || !lc ? (
                          ""
                        ) : (
                          <>
                            as LOW as <br />
                            <span className="text-bold">{lc.text}</span>
                            <br />
                            per User per {lc.unitWord}
                          </>
                        )}
                      </td>
                    ))}
                  </tr>
                )}

                {/* CTA row — ONLY SECTION TO REPLACE */}
                <tr>
                  {headers.map((hdr, i) => {
                    const isFreeCol = i === 0;

                    const hasActiveSub = this.state.existingPlan === true; // existing user
                    const wasSubscribed = this.state.subscribedBefore === true; // used trial before (no active now)
                    const isNewUser = !hasActiveSub && !wasSubscribed; // truly new

                    const isCurrent = hasActiveSub && currentPlanIndex === i;

                    let label, disabled;

                    if (isNewUser) {
                      label = isFreeCol
                        ? localizationStrings.ctaTryFree
                        : localizationStrings.ctaSubscribeNow;
                    } else if (hasActiveSub) {
                      if (isFreeCol) {
                        label = localizationStrings.ctaTryFree;
                        disabled = true;
                      } else if (isCurrent) {
                        label = localizationStrings.currentPlanButton;
                        disabled = true;
                      } else {
                        label = localizationStrings.ctaChangePlan;
                      }
                    } else {
                      label = isFreeCol
                        ? localizationStrings.ctaTryFree
                        : localizationStrings.ctaSubscribeNow;
                      disabled = isFreeCol;
                    }

                    const onClick = () => {
                      if (!disabled && !isCurrent) {
                        this.handleSubscriptionButtonClick(PLAN_KEYS[i]);
                      }
                    };

                    const title =
                      disabled && isFreeCol
                        ? localizationStrings.freeTrialUnavailable
                        : isCurrent
                        ? localizationStrings.currentPlanButton
                        : label;

                    return (
                      <td key={`cta-${i}`} className="border-y-none">
                        <button
                          className={`pricing-btn ${colorClasses[i]} ${
                            disabled || isCurrent ? "btnDisabled" : ""
                          }`}
                          disabled={disabled || isCurrent}
                          onClick={onClick}
                          title={title}
                        >
                          {isCurrent
                            ? localizationStrings.currentPlanButton
                            : label}
                        </button>
                      </td>
                    );
                  })}
                </tr>
              </thead>

              <tbody>
                {manageAndAdd.map((row, rIdx) => {
                  const isNfc = rIdx === 2; // NFC row index
                  const isRemarks = rIdx === 4; // Remarks row index

                  return (
                    <React.Fragment key={`feat-${rIdx}`}>
                      <tr className={isRemarks ? "remarks-row" : ""}>
                        <th
                          className={`th-iam ${
                            rIdx === 1 || rIdx === 2 ? "pad-start" : ""
                          }`}
                        >
                          {row.label}
                        </th>

                        {row.values.map((val, cIdx) => (
                          <td key={`feat-${rIdx}-${cIdx}`}>
                            {isRemarks ? (
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: String(val ?? ""),
                                }}
                              />
                            ) : (
                              val
                            )}
                          </td>
                        ))}
                      </tr>

                      {isNfc && (
                        <tr className="total-users-row">
                          <th className="th-iam">
                            {localizationStrings.labelTotalUsers}
                          </th>
                          {totalUsers.map((val, i) => (
                            <td key={`tot-${i}`}>
                              <strong>{val}</strong>
                            </td>
                          ))}
                        </tr>
                      )}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="warningMessage">
            <ContactCustomPlan />
            {localizationStrings.warningTitles2}
            <p className="warningMessage2">
              {localizationStrings.warningTitles3}
            </p>
          </div>

          <div>
            <button
              style={{ display: this.state.existingPlan ? "block" : "none" }}
              className={
                this.state.existingPlan
                  ? "cancelPlanBtn"
                  : "cancelPlanBtn btnDisabled"
              }
              disabled={!this.state.existingPlan}
              onClick={this.handleSubCancellation}
            >
              {localizationStrings.cancelSubTitle}
            </button>
            <br />
          </div>

          <Modal
            show={this.state.showCancellationForm}
            onHide={this.handleCloseModal}
          >
            <Modal.Header
              style={{
                backgroundColor: "rgb(54, 154, 246)",
                borderRadius: "5px 5px 0 0",
              }}
              closeButton
            >
              <Modal.Title style={{ textAlign: "center", color: "white" }}>
                {localizationStrings.cancellationHeader}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <p>1. {localizationStrings.feedbackQ1}</p>
              <div style={{ marginBottom: "25px", color: "grey" }}>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason1"
                    name="reason1"
                    value="We don't need the service anymore"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason1">
                    {localizationStrings.reason1}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason2"
                    name="reason2"
                    value="The service is difficult to use"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason2">
                    {localizationStrings.reason2}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason3"
                    name="reason3"
                    value="The service lacks features that we need"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason3">
                    {localizationStrings.reason3}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason4"
                    name="reason4"
                    value="We want to change the subscription plan"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason4">
                    {localizationStrings.reason4}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason5"
                    name="reason5"
                    value="We will move to another service provider instead"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason5">
                    {localizationStrings.reason5}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason6"
                    name="reason6"
                    value="It is too expensive"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason6">
                    {localizationStrings.reason6}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason7"
                    name="reason7"
                    value="We have privacy concerns"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason7">
                    {localizationStrings.reason7}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason8"
                    name="reason8"
                    value="The cancellation is only temporary"
                    onChange={this.handleReasonsSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason8">
                    {localizationStrings.reason8}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="checkbox"
                    id="reason9"
                    name="reason9"
                    value="Others"
                    onChange={(e) => {
                      this.handleReasonsSelection(e);
                      this.handleOtherReasons(e);
                    }}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="reason9">
                    {localizationStrings.reason9}
                  </label>
                  <br />
                </div>
                <div
                  style={{
                    margin: "10px 0 35px",
                    display: this.state.otherReasons ? "block" : "none",
                  }}
                >
                  <input
                    style={{ width: "100%", fontSize: "14px", padding: "5px" }}
                    type="text"
                    placeholder={localizationStrings.specifyReason}
                    value={this.state.statedReason}
                    onChange={this.handleReasonChange}
                  ></input>
                </div>
              </div>
              <p>2. {localizationStrings.feedbackQ2}</p>
              <div style={{ marginBottom: "25px", color: "grey" }}>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="radio"
                    id="duration1"
                    name="subscription-duration"
                    value="Less than a month"
                    onClick={this.handleSubDurationSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="duration1">
                    {localizationStrings.duration1}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="radio"
                    id="duration2"
                    name="subscription-duration"
                    value="1 - 3 months"
                    onClick={this.handleSubDurationSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="duration2">
                    {localizationStrings.duration2}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="radio"
                    id="duration3"
                    name="subscription-duration"
                    value="4 - 12 months"
                    onClick={this.handleSubDurationSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="duration3">
                    {localizationStrings.duration3}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="radio"
                    id="duration4"
                    name="subscription-duration"
                    value="1 - 2 years"
                    onClick={this.handleSubDurationSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="duration4">
                    {localizationStrings.duration4}
                  </label>
                  <br />
                </div>
                <div
                  style={{ display: "flex", gap: "12px", marginBottom: "6px" }}
                >
                  <input
                    style={{ margin: "0" }}
                    type="radio"
                    id="duration5"
                    name="subscription-duration"
                    value="More than 3 years"
                    onClick={this.handleSubDurationSelection}
                  ></input>
                  <label style={{ margin: "2px 0 0 0" }} htmlFor="duration5">
                    {localizationStrings.duration5}
                  </label>
                  <br />
                </div>
              </div>
              <p>3. {localizationStrings.feedbackQ3}</p>
              <div
                style={{
                  marginBottom: "35px",
                  color: "grey",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "end",
                }}
              >
                <p style={{ fontSize: "13px", whiteSpace: "nowrap" }}>
                  {localizationStrings.veryPoor}
                </p>
                <div
                  style={{
                    width: "70%",
                    display: "flex",
                    justifyContent: "space-between",
                    textAlign: "center",
                  }}
                >
                  {[...Array(10)].map((_, i) => (
                    <div
                      key={i + 1}
                      style={{ display: "flex", flexDirection: "column" }}
                    >
                      <label htmlFor={`rating${i + 1}`}>{i + 1}</label>
                      <input
                        type="radio"
                        id={`rating${i + 1}`}
                        name="service-rating"
                        value={String(i + 1)}
                        onClick={this.handleRatingSelection}
                      ></input>
                    </div>
                  ))}
                </div>
                <p style={{ fontSize: "13px", whiteSpace: "nowrap" }}>
                  {localizationStrings.excellent}
                </p>
              </div>
              <p>4. {localizationStrings.feedbackQ4}</p>
              <div style={{ marginBottom: "12px" }}>
                <textarea
                  style={{
                    width: "100%",
                    resize: "none",
                    color: "grey",
                    fontSize: "14px",
                    padding: "10px",
                  }}
                  rows="5"
                  value={this.state.additionalFeedback}
                  onChange={this.handleAdditionalFeedbackChange}
                ></textarea>
              </div>
              <button
                className="cancellationProceedBtn"
                onClick={this.handleSubmitCancellationForm}
              >
                {localizationStrings.proceed}
              </button>
              <button
                className="cancellationReturnBtn"
                onClick={this.handleCloseModal}
              >
                {localizationStrings.return}
              </button>
              {this.state.cancellationFormError && (
                <p style={{ color: "red", margin: "15px 0 -2px" }}>
                  {this.state.cancellationFormError}
                </p>
              )}
            </Modal.Body>
          </Modal>
        </div>
      </section>
    );
  }
}

const authCondition = (authUser) => !!authUser;

function StripeBtnNewWithElements(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <StripeBtnNew {...props} stripe={stripe} elements={elements} />
      )}
    </ElementsConsumer>
  );
}

export default withAuthorization(authCondition)(StripeBtnNewWithElements);
